import React from 'react';

import HtmlTemplateChangeset from '../components/HtmlTemplateChangeset';
import PdfTemplateChangeset from '../components/PdfTemplateChangeset';
import PrismTemplateChangeset from '../components/PrismTemplateChangeset';
import RawTemplateJsonTab from '../components/RawTemplateJsonTab';
import TemplateChangesSubtitle from '../components/TemplateChangesSubtitle';
import {
  FormHistoryPanel,
  FormSummaryKind,
  RAW_JSON_TAB,
  TEMPLATE_CHANGES_PANEL_TITLE,
} from '../FormChangeHistory.constants';
import { getTemplateJsonSides } from '../FormChangeHistory.utils';

/** The template fields' changesets, by the kind the Forms service summarises each field as. */
export const FORM_TEMPLATE_RENDERERS = {
  [FormSummaryKind.PRISM_TEMPLATE]: PrismTemplateChangeset,
  [FormSummaryKind.PDF_FILE]: PdfTemplateChangeset,
  [FormSummaryKind.PDF_FIELD_MAPPING]: PdfTemplateChangeset,
  [FormSummaryKind.HTML_FILE]: HtmlTemplateChangeset,
};

/** Template changes need the drill-in's full width, so they leave the field diff for a panel. */
export const FORM_HISTORY_CHANGE_PANELS = [
  {
    id: FormHistoryPanel.TEMPLATE,
    title: TEMPLATE_CHANGES_PANEL_TITLE,
    kinds: Object.values(FormSummaryKind),
    subtitle: TemplateChangesSubtitle,
  },
];

/** A Raw JSON tab on a change whose Prism document exists on at least one side. */
export const renderFormDetailExtras = (row, detail) => {
  const sides = getTemplateJsonSides(detail);

  return sides.length > 0
    ? [
        {
          id: RAW_JSON_TAB.id,
          label: RAW_JSON_TAB.label,
          content: <RawTemplateJsonTab auditId={detail.summary.auditId} sides={sides} />,
        },
      ]
    : [];
};
